import { CalendarContainer } from '@/components/schedule/CalendarContainer'

export function SchedulePage() {
  return (
    <div className="space-y-4 h-full">
      <CalendarContainer />
    </div>
  )
}
